// Enregistrer un fichier depuis l'application mobile.
//
// Le téléchargement classique du web (lien avec `download` puis clic) ne fait
// RIEN dans une WebView : le clic s'exécute sans erreur mais aucun fichier
// n'arrive sur l'appareil (vérifié sur émulateur Android). Dans l'app, on écrit
// donc le fichier puis on ouvre le panneau de partage du téléphone, qui permet
// de l'enregistrer, l'envoyer par mail, l'ouvrir dans une autre app, etc.

export function isNativeApp() {
  return (
    typeof window !== "undefined" &&
    !!window.Capacitor &&
    typeof window.Capacitor.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform()
  );
}

/**
 * Propose un fichier texte à l'utilisateur (partage natif).
 * @returns {Promise<boolean>} false si les plugins ne sont pas disponibles,
 *          auquel cas l'appelant doit garder le téléchargement web habituel.
 */
export async function shareTextFile(filename, content, title = "") {
  const plugins = window.Capacitor?.Plugins;
  const Filesystem = plugins?.Filesystem;
  const Share = plugins?.Share;
  if (!Filesystem?.writeFile || !Share?.share) return false;

  const written = await Filesystem.writeFile({
    path: filename,
    data: content,
    directory: "CACHE",
    encoding: "utf8",
    recursive: true,
  });
  await Share.share({
    title: title || filename,
    files: [written.uri],
  });
  return true;
}
